package ru.it_mozaika.sender.js.application.components.segments

import mui.material.*
import react.FC
import react.Props
import react.ReactNode
import react.useMemo
import ru.it_mozaika.sender.common.models.CompareType
import ru.it_mozaika.sender.common.models.CompareType.IS_FILLED
import ru.it_mozaika.sender.common.models.CompareType.LESS_THAN_DAYS_COUNT

external interface RuleCompareTypeSelectProps : Props {
    var availableTypes: List<Int>
    var value: Int
    var onSelect: (Int) -> Unit
}

private val typeTitles = mapOf<Int, String>(
    CompareType.UNKNOWN to "Неизвестно",
    CompareType.EQUALS to "Равно",
//    CompareType.NOT_EQUALS to "Не Равно",

    CompareType.CONTAINS to "Содержит",
    CompareType.STARTS_WITH to "Начинается с",
    CompareType.ENDS_WITH to "Заканчивается на",

    CompareType.LESS to "Меньше",
    CompareType.LESS_EQUALS to "Меньше или равно",
    CompareType.GREATER_EQUALS to "Больше или равно",
    CompareType.GREATER to "Больше",
    CompareType.IN_RANGE to "В диапазоне",
//    CompareType.NOT_IN_RANGE to "Не в диапазоне",

    CompareType.LESS_THAN_DAYS_COUNT to "Меньше, чем кол-во дней",
    CompareType.GREATER_THAN_DAYS_COUNT to "Больше, чем кол-во дней",

    CompareType.IN_LIST to "В списке",
    CompareType.IS_FILLED to "Заполнено"
//    CompareType.EMPTY to "Не заполнено",

//    CompareType.NOT_EMPTY to "Заполнено"
)

private val typesToExcludeInNegative =
    listOf(
        CompareType.UNKNOWN,
        CompareType.LESS,
        CompareType.LESS_EQUALS,
        CompareType.GREATER_EQUALS,
        CompareType.GREATER,
        CompareType.LESS_THAN_DAYS_COUNT,
        CompareType.GREATER_THAN_DAYS_COUNT
    )
val RuleCompareTypeSelect = FC<RuleCompareTypeSelectProps> { props ->
    val types = useMemo(props.availableTypes) {
        typeTitles.filterKeys { props.availableTypes.contains(it) }
    }

    FormControl {
        InputLabel {
            color = FormLabelColor.secondary
            this.id = "rule-compare-type"
            +"Тип сравнения"
        }
        Select {
            color = InputBaseColor.secondary
            value = props.value
            labelId = "rule-compare-type"
            label = ReactNode("Тип сравнения")
            onChange = { e, _ ->
                props.onSelect(e.target.value.unsafeCast<Int>())
            }
            types.forEach { (key, title) ->
//                MenuItem {
//                    this.value = key
//                    +title
//                }
                MenuItem {
                    this.value = key
                    +title
                }
                if (!typesToExcludeInNegative.contains(key)) MenuItem {
                    this.value = key * -1
                    +"НЕ $title"
                }
            }
        }
    }
}